<template>
    <div class="router-view-content">
        <h1>Kursy</h1>
        <h2>Edytuj kurs z listy lub dodaj nowy</h2>
        <div
            style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0.5rem 0;
            "
        >
            <input placeholder="Szukaj" @input="searchWebinars" type="search" />
            <div class="flex-row">
                <ActionButton
                    label="Dodaj kurs"
                    color="apple"
                    @click="goToCreator"
                />
                <ActionButton
                    label="Importuj kursy"
                    color="apple"
                    :loading="loading"
                    @click="importWebinars"
                />
            </div>
        </div>
        <RegularList
            @itemSelected="editCourse"
            :loading="initLoading"
            :header="listHeader"
            :items="listItems"
        />
        <transition name="fade">
            <CourseCreator
                @close="creatorVisible = false"
                v-if="creatorVisible"
            />
        </transition>
    </div>
</template>
<script>
import { timeout } from 'q'
import courses from '../../VOD/Course/courseData'
export default {
    components: {
        CourseCreator: () => import('./CourseCreator')
    },
    data() {
        return {
            loading: false,
            listHeader: [
                {
                    display: 'Tytuł',
                    size: 2
                },
                {
                    display: 'Koszt',
                    size: 2
                }
            ],
            creatorVisible: false,
            initLoading: true,
            timeout: timeout
        }
    },
    computed: {
        listItems() {
            return this.$store.state.content.courses.map(course => {
                return {
                    key: course.uuid,
                    payload: course,
                    cells: [
                        {
                            type: 'text',
                            display: course.title,
                            size: 2
                        },
                        {
                            type: 'text',
                            display: course.cost / 100 + ' zł',
                            size: 2
                        }
                    ]
                }
            })
        }
    },
    methods: {
        importWebinars() {
            if (this.loading) {
                return
            }
            this.loading = true
            const webinars = courses
            const promises = webinars.map(w => {
                const webinar = JSON.parse(JSON.stringify(w))
                if (this.isDuplicated(webinar)) {
                    this.$Notif.error('', 'Duplikat')
                    return Promise.resolve()
                }
                const { author } = webinar
                const { certificate } = webinar
                let data = webinar
                data.author_name = author ? author.name : ''
                data.author_description = author ? author.description : ''
                data.author_image = author ? author.image : ''
                delete data.author
                data.certificate_title = certificate ? certificate.title : ''
                data.certificate_description = certificate
                    ? certificate.description
                    : ''
                data.certificate_host = certificate ? certificate.host : ''
                data.preview_url = webinar.preview_url
                    ? webinar.preview_url
                    : ''
                data.old_cost = webinar.old_cost ? webinar.old_cost : 0
                data.cost = webinar.cost ? webinar.cost : 0
                data.visible = webinar.visible ? webinar.visible : true
                data.modules = webinar.modules ? webinar.modules : []
                const customDescription = webinar.customDescription
                    ? webinar.customDescription
                    : ''
                const description = webinar.description
                    ? webinar.description
                    : ''
                data.description = `${description} ${customDescription}`
                delete data.certificate
                return this.$api.post(`v1/vod/courses`, data)
            })
            Promise.all(promises)
                .then(() => {
                    this.getCourses()
                })
                .catch(error => {
                    this.$Network.handleError(error)
                })
                .then(() => {
                    this.loading = false
                })
        },
        isDuplicated(webinar) {
            return this.$store.state.content.courses.some(
                w => w.uuid == webinar.uuid
            )
        },
        editCourse(course) {
            this.$router.push(`courses/${course.id}`)
        },
        searchWebinars(input) {
            const search = `"*${input.target.value}*"`
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                const query = `?query=(title=i=${search}))`
                this.getCourses(query)
            }, 1000)
        },
        goToCreator() {
            this.$router.push('courses/new')
        },
        getCourses(q) {
            this.$store
                .dispatch('content/getCourses', q)
                .catch(error => {
                    this.$Network.handleError(error)
                })
                .then(() => {
                    this.initLoading = false
                })
        }
    },
    mounted() {
        this.getCourses()
    }
}
</script>
